export const getCoursesParams = state => state.getIn(['routing', 'coursesRouter', 'params'])
export const getJobsParams = state => state.getIn(['routing', 'jobsRouter', 'params'])
export const getSkillsParams = state => state.getIn(['routing', 'skillsRouter', 'params'])
export const getActiveScreen = state => state.getIn(['routing', 'mainRouter', 'active'])
export const getActiveScreenPage = (state) => state.getIn(['routing',`${getActiveScreen(state)}Router`, 'active'])